'use client';

import { EmailPrefix, EMAIL_PREFIXES } from '../lib/types';
import EmailPreview from './EmailPreview';

interface Step4Props {
  domain: string;
  selectedEmails: EmailPrefix[];
  onToggle: (prefix: EmailPrefix) => void;
  onNext: () => void;
  onBack: () => void;
}

export default function Step4EmailSimulator({
  domain,
  selectedEmails,
  onToggle,
  onNext,
  onBack,
}: Step4Props) {
  return (
    <div className="animate-fade-in max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-2">Configurez vos adresses email</h2>
      <p className="text-muted mb-6">
        Sélectionnez les adresses que vous souhaitez créer pour{' '}
        <span className="font-mono text-primary font-medium">{domain}</span>
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {EMAIL_PREFIXES.map((prefix, i) => {
          const isSelected = selectedEmails.includes(prefix.value);
          const email = `${prefix.value}@${domain}`;

          return (
            <button
              key={prefix.value}
              onClick={() => onToggle(prefix.value)}
              className={`flex items-start gap-3 p-3.5 rounded-lg border-2 transition-all duration-200 text-left cursor-pointer animate-slide-in ${
                isSelected
                  ? 'border-primary bg-primary-light/50'
                  : 'border-border hover:border-primary/30'
              }`}
              style={{ animationDelay: `${i * 40}ms` }}
            >
              <div
                className={`w-5 h-5 rounded border-2 flex items-center justify-center shrink-0 mt-0.5 transition-colors ${
                  isSelected
                    ? 'border-primary bg-primary text-white'
                    : 'border-border'
                }`}
              >
                {isSelected && <span className="text-xs">&#10003;</span>}
              </div>
              <div className="min-w-0">
                <p className="font-mono text-sm font-medium truncate">{email}</p>
                <p className="text-xs text-muted mt-0.5">{prefix.description}</p>
              </div>
            </button>
          );
        })}
      </div>

      <EmailPreview domain={domain} emails={selectedEmails} />

      <div className="flex gap-3 mt-8">
        <button
          onClick={onBack}
          className="px-6 py-3 rounded-lg border border-border text-muted hover:bg-gray-50 transition-colors cursor-pointer"
        >
          Retour
        </button>
        <button
          onClick={onNext}
          disabled={selectedEmails.length === 0}
          className="flex-1 bg-primary hover:bg-primary-hover disabled:opacity-40 disabled:cursor-not-allowed text-white font-semibold py-3 rounded-lg transition-colors cursor-pointer"
        >
          Voir le récapitulatif
        </button>
      </div>
    </div>
  );
}